import KBAQuestions from 'ui/sections/notarize/pages/KBAQuestions';
import { NotarizationStatus } from 'utils/enums';

export default class SpouseKBAQuestions extends KBAQuestions {
  static forSpouse = true;
  static notarizationSection = NotarizationStatus.KBA_SPOUSE;
}
